import { Cell, CellProps } from "./cell";
import { useRef } from "react";
import styles from "./cell.module.scss";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../Tooltip";

export const CellHeader = ({
  children,
  showTooltip = true,
  ...props
}: CellProps) => {
  const textRef = useRef<HTMLDivElement>(null);
  const actualRef = useRef<HTMLDivElement>(null);

  const isTextOverflown =
    actualRef.current && textRef.current
      ? textRef.current.clientWidth > actualRef.current.clientWidth
      : false;

  const tooltipText =
    children && typeof children === "string" ? children.toString() : null;

  return (
    <Cell {...props}>
      <div>
        {/*
          This text does not get displayed!
          This element will determine if the text width is greater than the container width.
          Which will ultimately display a tooltip if so. 
          */}
        <div ref={textRef} className={styles.tooltipTriggerText} aria-hidden>
          {children}
        </div>

        {!isTextOverflown || !showTooltip || !tooltipText ? (
          <div ref={actualRef} className={styles.cellContent}>
            {children}
          </div>
        ) : (
          <Tooltip>
            <TooltipTrigger asChild>
              <div ref={actualRef} className={styles.cellContent}>
                {children}
              </div>
            </TooltipTrigger>

            <TooltipContent
              style={{ zIndex: 9999 }}
              variant="small"
              align="center"
              side="right"
            >
              {tooltipText}
            </TooltipContent>
          </Tooltip>
        )}
      </div>
    </Cell>
  );
};
